// @ts-nocheck
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

export default function RoleBasedGuard({ accessibleRoles, children }) {
  const { user } = useAuth();
  const currentRole = user?.role;

  if (!currentRole || !accessibleRoles.includes(currentRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
